module.exports = "\r\n<div class=\"tgui-barcode img-container center tg-barcode\" v-show=\"realContent\">\r\n\t<img alt=\"\">\r\n</div>\r\n";